<template>
	<v-dialog :fullscreen="isMobile" scrollable attach ref="eventRSVPSuccessModal" v-model="eventRsvpSuccessModalOpen" max-width="700px">
		<v-card raised v-if="getEvent">
			<v-card-title class="display-1 modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="eventRsvpSuccessModalOpen=false">
					<v-icon large>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding">
				<p class="mb-3 event-rsvp-success__header">
					Thank you {{ user.first_name }}!
				</p>
				<p v-if="requiresApproval" class="event-rsvp-success__content mb-2">You have applied to be approved for:</p>
				<p v-else-if="getPrice > 0 && !freePass" class="event-rsvp-success__content mb-2">Your ${{ getPrice }} purchase was authorized, and reservation request submitted for:</p>
				<p v-else class="event-rsvp-success__content mb-2">You have registered for this free event:</p>
				<div class="event-page-details-table ml-2 mt-2">
					<div class="event-page-details-flex">
						<div class="details-icon" style="width: 50px;">
							<i style="font-size:1.55em;" class="success--text fal fa-map-marker"></i>
						</div>
						<div class="content">
							{{getEvent.title}}
						</div>
					</div>
					<div class="event-page-details-flex">
						<div class="details-icon" style="width: 50px;">
							<i style="font-size:1.55em;" class="info--text fal fa-clock"></i>
						</div>
						<div class="content">
							{{ formattedTime }} {{eventDate}}
						</div>
					</div>
				</div>
				<p v-if="getModalProp('eventRSVPSuccessModalAddons')" class="event-rsvp-success__content mb-0 mt-2">Your purchase includes ${{getEvent.addons[0].price}} {{getEvent.addons[0].title}} {{getEvent.addons[0].time_slot}} the event from {{getEvent.addons[0].start_time}} to {{getEvent.addons[0].end_time}}</p>
				<div style="border-bottom: 1px solid lightgray;" class="mt-4 mb-4"></div>
				<p class="mb-3 event-rsvp-success__sub-header">Next Steps:</p>
				<div class="display: flex; flex-direction: column; justify-content: space-between;">
					<div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
						<v-card flat width="65" height="65" class="pa-0 mr-3">
							<v-layout column align-center justify-center style="height: 100%; width: 100%">
								<i class="fal fa-calendar-plus success--text" style="font-size: 4.0em; cursor: pointer;" @click="openAddToCalendarModal"></i>
							</v-layout>
						</v-card>
						<div style="width: 85%; display: flex; flex-direction: column; justify-content: flex-end;">
							<p class="success--text mb-1" @click="openAddToCalendarModal" style="cursor: pointer;">Add this event to your calendar</p>
							<p class="d-inline-block mb-0 event-rsvp-success__content">Before it slips your mind, add this event to your normal calendar (gCal, iCal, etc.) right NOW! Its easy … just click the icon to the left or link above.</p>
						</div>
					</div>
					<div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;" class="mt-4">
						<v-card flat width="65" height="65" class="pa-0 mr-3">
							<v-layout column align-center justify-center style="height: 100%; width: 100%;">
								<i class="fal fa-users info--text" style="font-size: 3.5em; cursor: pointer;" @click="openShareModal"></i>
							</v-layout>
						</v-card>
						<div style="width: 85%; display: flex; flex-direction: column; justify-content: flex-end;">
							<p class="info--text mb-1" @click="openShareModal" style="cursor: pointer;">Invite a friend or two ... or more!</p>
							<p class="d-inline-block mb-0 event-rsvp-success__content">WRKPRTY events are always even better when friends see friends and get a chance to connect a bit around work. Don't be shy, they'll thank you.</p>
						</div>
					</div>
					<div class="text-xs-right" style="vertical-align: middle">
						<v-btn flat color="info" @click="clickWrkprtyLogo">Return to Dashboard</v-btn><img @click="clickWrkprtyLogo" src="/static/images/navbar/logo-color.svg" height="32" style="margin-top: 6px; cursor: pointer;" alt="" />
					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import AddToCalendar from '~/components/AddToCalendar.vue'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'event_rsvp_success_modal',
	data() {
		return {}
	},
	components: {
		AddToCalendar
	},
	methods: {
		...mapActions([
			'setShareModalEvent',
			'setModalOpen',
			'setModalProp',
			'setCalendarModalEvent'
		]),
		clickWrkprtyLogo() {
			this.eventRsvpSuccessModalOpen = false
			this.$router.push('/dashboard')
		},
		timeToAMPM(timeString) {
			let time = timeString
				.toString()
				.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeString]

			if (time.length > 1) {
				time = time.slice(1)
				if (time.length > 3) {
					time.pop()
				}
				time[3] = time[0] < 12 ? 'a' : 'p'
				time[0] = +time[0] % 12 || 12
			}
			// console.log(time)
			return time.join('')
		},
		openShareModal() {
			this.setShareModalEvent(this.getEvent)
			this.setModalOpen({ prop: 'shareModal', value: true })
			console.log('open share modal')
		},
		openAddToCalendarModal() {
			this.setModalOpen({ prop: 'calendarModal', value: true })
			this.setCalendarModalEvent(this.getEvent)
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getAllEvents',
			'getEventRSVPSuccessModalEvent',
			'getModalProp'
		]),
		requiresApproval() {
			if (this.getEvent.restrictions.approval === 'all_need_approval') {
				return true
			}
			if (this.getEvent.restrictions.approval === 'level_one') {
				return true
			}
		},
		getPrice () {
			// axios.get('/api/v1/payment-object/' + this.getEvent.pk + '/user/' + this.user.pk + '/').then((response) => {
			// 	console.log(response)
			// 	console.log('asdaasdff')
			// }).catch((error) => {
			// 	console.log(error)
			// })
			let price = 0.0
			// if (this.getModalProp('eventRSVPSuccessModalAddons') !== null) {
			// 	if (this.getModalProp('eventRSVPSuccessModalAddons').length > 0) {
			// 		price += parseFloat(this.getModalProp('eventRSVPSuccessModalAddons')[0].price)
			// 	}
			// }
			price += this.getEvent.final_price
			return price
		},
		getLocationAddress() {
			let locationString = ''
			if (this.location.hasOwnProperty('address')) {
				let addressComponents = []
				if (this.location.address.hasOwnProperty('street_number')) {
					if (this.location.address.hasOwnProperty('route')) {
						addressComponents.push(
							this.location.address.street_number +
								' ' +
								this.location.address.route
						)
					}
				}
				if (this.location.address.hasOwnProperty('city')) {
					addressComponents.push(this.location.address.city)
				}
				if (this.location.address.hasOwnProperty('state')) {
					addressComponents.push(this.location.address.state)
				}
				if (this.location.address.hasOwnProperty('country')) {
					if (this.location.address.country !== 'United States') {
						addressComponents.push(this.location.address.country)
					}
				}
				for (var i = 0; i < addressComponents.length; i++) {
					locationString += addressComponents[i]
					if (i < addressComponents.length - 1) {
						locationString += ', '
					}
				}
			}
			return locationString
		},
		location() {
			return this.getEvent.location
		},
		eventDate() {
			return moment(this.getEvent.date).format('MMM Do')
		},
		formattedTime() {
			let start = this.timeToAMPM(this.getEvent.time_start)
			let end = this.timeToAMPM(this.getEvent.time_end)

			if (!start || !end) {
				return ''
			}

			let startSuffix = ''
			let endSuffix = ''

			if (start.includes('a')) {
				startSuffix = 'a'
			} else {
				startSuffix = 'p'
			}

			if (end.includes('a')) {
				endSuffix = 'a'
			} else {
				endSuffix = 'p'
			}

			return (
				start.split(':')[0] +
				startSuffix +
				' - ' +
				end.split(':')[0] +
				endSuffix
			)
		},
		getEvent() {
			return this.getEventRSVPSuccessModalEvent
		},
		eventRsvpSuccessModalOpen: {
			get() {
				return this.getModalProp('eventRSVPSuccessModal')
			},
			set(value) {
				this.setModalOpen({ prop: 'eventRSVPSuccessModal', value: value })
				if (value === false) {
					this.setModalProp({
						prop: 'eventRSVPSuccessModalAddons',
						value: null
					})
				}
			}
		},
		shareModalOpen: {
			get() {
				return this.getModalProp('shareModal')
			},
			set(val) {
				console.log('sharemodalopen')
				this.setShareModalEvent(this.getEvent)
				this.setModalOpen({ prop: 'shareModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
		freePass() {
			if (this.getEvent) {
				if (this.user.free_pass) {
					if (this.getEvent.location.free_pass_allowed) {
						return true
					}
				}
			}
			return false
		}
	}
}
</script>

<style lang="scss">
.event-rsvp-success__header {
	font-size: 1.8em;
	font-family: 'Quantico';
	color: #666;
}

.event-rsvp-success__content {
	font-size: 0.9em;
	color: #777;
}
.event-rsvp-success__sub-header {
	font-size: 1em;
	color: #999;
}
</style>
